"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piova-massaia": {
    "3983fb6e": [{
      "hkey": "dd99ed13",
      "slug": "piova-massaia",
      "name": "Piovà Massaia",
      "primary": true,
      "skipSearch": false
    }],
    "castelvero": [{
      "hkey": "dd99ed13",
      "slug": "piova-massaia",
      "name": "Piovà Massaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;